import styled from '@emotion/styled';
import { ListItemButton } from '@mui/material';
import { Colors } from 'styles/variables/colors';
import { TextStyle } from 'styles/variables/mixins';

type BurgerMenuProps = {
    isActive: boolean;
};

export const BurgerMenu = styled.button<BurgerMenuProps>`
    fill: ${Colors.darkGray};
`;

export const DropDownMenu = styled.ul`
    border-radius: 4px;
    padding: 10px;
    gap: 5px;
    border: 1px solid ${Colors.tableBorder};
    box-shadow:
        0px 1px 2px rgba(0, 0, 0, 0.3),
        0px 1px 3px 1px rgba(0, 0, 0, 0.15);
`;

export const MenuItem = styled(ListItemButton)`
    padding: 0;
`;

export const Item = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    height: 40px;
    border-radius: 2px;
    padding: 10px;
    width: 100%;
    ${TextStyle({ fontSize: '15px', fontWeight: '500', color: Colors.darkGray })};
`;
